import { defaultLensOf } from "../../lib/lenses/lensRegistry.js";

// LensHost — the spine's render seam. Resolves the set of lenses for the
// current nav target and mounts the ACTIVE one. Which lens is active is driven
// by the `view` nav field (set from the sidebar's lens links); with no view it
// falls to the set's default (an explicit defaultActive lens, else the scope
// overview, else the first). No center chrome — lens selection lives in the
// sidebar, next to the value. The Body is keyed by lens.id so switching
// remounts cleanly, isolating each lens's hooks (incl. any data-fetching a lens
// owns). See lensRegistry.js for the resolution cascade.
export default function LensHost({ registry, target, slot, ctx }) {
  const lenses = registry.resolveLenses(target);
  if (!lenses.length) return null;
  const active = (target?.view && lenses.find((l) => l.id === target.view)) || defaultLensOf(lenses);
  if (!active) return null;
  const Body = active.Body;
  return <Body key={active.id} nav={target} slot={slot} ctx={ctx} />;
}
